import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {RatesSroMasterService} from 'src/app/services/rates-sro-master/rates-sro-master.service';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {HhgRateQueryService} from 'src/app/services/hhg-rate-query/hhg-rate-query.service';
import {UserService} from 'src/app/services/user/user.service';
import {Router} from '@angular/router';
import {HHGRateQueryRequest, HHGRateQueryResult, StateCountry} from 'src/app/shared/common-components/common-structure';
import {distinctUntilChanged, filter, shareReplay, switchMap, takeWhile, tap, first, map, startWith} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, Observable, of, pipe, ReplaySubject, Subject, zip} from 'rxjs';
import {CommonValidators} from 'src/app/shared/common-components/common-validators';
import {RoundPipe} from './round-pipe';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {User} from 'src/app/services/user/user';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import AppConstants, {
  carrier_user,
  carrier_user_admin,
  carrier_user_RF
} from '../../shared/common-components/AppConstants';
import * as _ from 'lodash';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {UserPreferencesService} from 'src/app/services/user-preferences/user-preferences.service';
import {UserPreference} from '../user-preferences/user-preference';
import {PrefItem} from '../user-preferences/pref-item';

@Component({
    selector: 'app-hhg-rate-query',
    templateUrl: './hhg-rate-query.component.html',
    styleUrls: ['./hhg-rate-query.component.css'],
    standalone: false
})
export class HhgRateQueryComponent implements OnInit, OnDestroy {

  private observer$ = new BehaviorSubject(true);
  private estimatedMileageWarning: Boolean = false;
  private estimatedMileageWarningMessage = '';
  private estimatedWeightWarning: Boolean = false;
  private estimatedWeightWarningMessage = '';
  private canadaStateCountryId = new ReplaySubject<number>(1);
  private sroType = new ReplaySubject<string>(1);
  private moveDate = new ReplaySubject<Date>(1);
  private defaultCountry = new BehaviorSubject<StateCountry>(null);
  allCountriesObj$:Subject<any[]> = new BehaviorSubject<any>([]);
  removedCountry = new Array();
  extendedStorage: Boolean;
  tmssloader: any;
  minWeight;
  modalRef: BsModalRef;
  effectiveExpDateObj$;
  excludedSroMasterIds: any;
  isInternational: any;
  isShownUAB = false;
  showComments: boolean;
  showResults = false;
  sroList: any;
  sroListOriginal: any;
  sroListMaster: any;
  sitValues: any = ['Destination', 'Origin'];
  sitBreakdownValues: any = ['Yes', 'No'];
  sroTypes: any = [
    'General',
    'Alternating',
    'Non-Alternating',
    'Extended Storage'
  ];
  vehicles: any = [
    {description: 'Class 1 - Less Than 300 CFt', name: 'Class 1'},
    {description: 'Class 2 - Between 300 and 800 CFt', name: 'Class 2'},
    {description: 'Class 3 - Exceeding 800 CFt', name: 'Class 3'}
  ];
  hhgRateQueryForm: UntypedFormGroup;
  excelHeaderString = '';
  userPref: UserPreference;
  userPrefList: PrefItem[];
  screenName: any;

  // Async sources for drop down lists
  hhgRateQueryResults$ = this.hhgRateQueryService.hhgRateQueryResults$;
  provincesList$ = this.canadaStateCountryId.pipe(
    distinctUntilChanged(),
    switchMap((stateId) => {
      return this.stateCountryService
        .getStateCountryByParentCountryId(stateId);
    }),
    shareReplay(1)
  );
  // sroList$ = this.sroType.pipe(
  //   distinctUntilChanged(),
  //   switchMap((sroType) => {
  //     return this.ratesSroMasterService
  //       .getSroLlistByBusinessTypeAndSroType(sroType);
  //   })
  // );

  // sroList$ = combineLatest([
  //   this.sroType,
  //   this.moveDate
  // ]).subscribe(([sro, move]) => {
  //     console.log(sro + ' --------' + move);
  //     return this.ratesSroMasterService.getSroLlistByBusinessTypeAndSroType(sro, move);
  // });

  allCountriesList$ = this.stateCountryService.getAllCountries().pipe(
    tap((allCountries) => {
      allCountries.forEach((item:any) => {
        if(item.businessType.toLowerCase().indexOf('hhg') > -1){
          if(item.stateCountryCode.toUpperCase() === '925E' || item.stateCountryCode.toUpperCase() === '925S') this.removedCountry.push(item);
        }
      });
    }),
    map(stateCountries => stateCountries.filter(country => {
      return this.filterData(country);
    })),

    tap((allCountries) => {
      const defaultOrigin = allCountries.find(x => {
        return x.stateCountryCode === 'US00';
      });
      this.defaultCountry.next(defaultOrigin);
    }),
    shareReplay(1)
  );

  dataSourceOriginSearchResults$: Observable<any>;
  dataSourceDestinationSearchResults$: Observable<any>;
  message = '';
  minDate = new Date();
  currentUser: User;

  filterData(item: any){
    if(item.businessType.toLowerCase().indexOf('hhg') > -1){
      if(new Date() >= new Date("2024-05-01")){
        if(item.stateCountryCode.toUpperCase() !== '925E' || item.stateCountryCode.toUpperCase() !== '925S') return item;
      }else {
        return item;
      }
    }else{ return ;}

  }
  constructor(
    private fb: UntypedFormBuilder,
    private ratesSroMasterService: RatesSroMasterService,
    private stateCountryService: StateCountryService,
    private hhgRateQueryService: HhgRateQueryService,
    private userService: UserService,
    private router: Router,
    private alertService: AlertService,
    private loader: LoadingService,
    private hhgrateService: HhgCarrierRateFilingService,
    private modalService: BsModalService,
    private userPreferencesService: UserPreferencesService
  ) {
    this.minDate.setFullYear(this.minDate.getFullYear() - 6);
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
  }

  ngOnInit() {
    this.hhgRateQueryFormInitialize();
    this.filterCountriesByPickupDate(this.hhgRateQueryForm.get('pickupDate').value);
    this.gettingShipmentID();
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    this.hhgRateQueryForm.get('origin.usaLocation.city').setValue(e.item);
  }

  typeaheadDestinationOnSelect(e: TypeaheadMatch): void {
    this.hhgRateQueryForm.get('destination.usaLocation.city').setValue(e.item);
  }

  hhgQuery() {

    const sroId = this.sroListMaster.length !== 0 ? this.sroListMaster.filter(x => x.sroMasterId === this.hhgRateQueryForm.get('sroMasterId').value) : [];
    const origin = this.hhgRateQueryForm.get('origin') ? this.hhgRateQueryForm.get('origin').value : null;
    const destination = this.hhgRateQueryForm.get('destination') ? this.hhgRateQueryForm.get('destination').value : null;
    if (sroId[0].sroId.toUpperCase() === 'DEADC' && origin.country.stateCountryId === 326 && destination.country.stateCountryId === 326) {
      this.alertService.info('DEADC SRO is only allowed for international shipments');
    } else if (sroId[0].sroId.toUpperCase() === 'FBPDC' 
                  && origin.country.stateCountryId === 326 && destination.country.stateCountryId === 326
                  && new Date(this.hhgRateQueryForm.get('pickupDate')?.value) >= new Date('2025-05-01')) {
                    this.alertService.warn('FBPDC SRO is allowed ONLY for International Shipments');
    } else {
      this.showResults = true;
      this.showComments = (!this.excludedSroMasterIds.some(sro => sro.sroMasterId === this.hhgRateQueryForm.get('sroMasterId').value)) && !this.isInternational;
      const excelHeader = this.getExcelHeader(origin, destination);
      this.excelHeaderString = Object.keys(excelHeader).map(t => t + ':' + excelHeader[t]).join(';  ');
      this.hhgRateQueryResults$ = this.hhgRateQueryService.hhgRateQueryResults$;
      this.hhgRateQueryService.updateHHGRateQueryRequest(
        this.getHHGRateQueryRequest()
      );
      this.getUserPrefs();
    }
  }

  getUserPrefs() {
    const userId = this.currentUser.userSessionEntity.userId;
    const orgId = this.currentUser.userSessionEntity.organizationId;
    let queryScreenName;
    this.hhgRateQueryForm.get('rateType').value === 'Extended Storage'
      ? queryScreenName = 'HHGExtResults' : queryScreenName = 'HHGResults';
    this.userPreferencesService.getUserPrefs(userId, orgId, queryScreenName).subscribe(result => {
      this.userPref = result;
      this.userPrefList = this.userPref.listPrefs;
      this.screenName = this.userPref.screenName;
    }, error => {
      this.alertService.error('Error while retreiving the user preferences');
    });
  }

  getExcelHeader(origin: any, destination: any) {
    return {
      PickupDate: this.hhgRateQueryForm.get('pickupDate').value.toISOString().substring(0, 10),
      RateType: this.hhgRateQueryForm.get('rateType').value,
      SROCode: this.sroListMaster.find(x => x.sroMasterId === this.getHHGRateQueryRequest().sroMasterId).sroId,
      Origin: origin ? this.getHeaderAddressColumn(origin) : '',
      Destination: destination ? this.getHeaderAddressColumn(destination) : '',
      ContainerizedShipments: this.hhgRateQueryForm.get('containerizedShipments') ? this.hhgRateQueryForm.get('containerizedShipments').value : '',
      VehicleClass: this.hhgRateQueryForm.get('vehicleClass') ? this.hhgRateQueryForm.get('vehicleClass').value : '',
      EstimatedWeight: this.hhgRateQueryForm.get('estimatedWeight') ? this.hhgRateQueryForm.get('estimatedWeight').value : '',
      EmployeeFirstName: this.hhgRateQueryForm.get('employeeFirstName') ? this.hhgRateQueryForm.get('employeeFirstName').value : '',
      EmployeeMiddleName: this.hhgRateQueryForm.get('employeeMiddleName') ? this.hhgRateQueryForm.get('employeeMiddleName').value : '',
      EmployeeLastName: this.hhgRateQueryForm.get('employeeLastName') ? this.hhgRateQueryForm.get('employeeLastName').value : '',
      SIT: this.hhgRateQueryForm.get('sit') ? this.hhgRateQueryForm.get('sit').value : '',
      SITBreakdown: this.hhgRateQueryForm.get('sitBreakdown') ? this.hhgRateQueryForm.get('sitBreakdown').value : '',
      Miles: this.hhgRateQueryForm.get('miles') ? this.hhgRateQueryForm.get('miles').value : ''
    };
  }

  getHeaderAddressColumn(address: any) {
    let result = '';
    if (address.usaLocation) {
      result = address.usaLocation.zip + ' ' + address.usaLocation.cityName + ' ' + address.usaLocation.state;
    }
    if (address.canadaLocation && address.canadaLocation.province) {
      result = address.canadaLocation.province.stateCountryName;
    }
    return result + ' ' + address.country.stateCountryName;
  }

  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  onhhgRateQuerySelected(hhgRateSelectedItem: HHGRateQueryResult) {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, you want to continue with the selection';
    this.modalRef.content.title = 'HHG Query Item Selection';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.pipe(takeWhile(() => this.observer$.value))
      .subscribe(result => {
        if (result.obj === true) {
          this.hhgRateQueryService.saveBookShipmentDetailsForHHGRateQuery(hhgRateSelectedItem)
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(bookshipmentid => {
              this.router.navigate(['/', 'hhgbookshipment'],
                {queryParams: {bookshipmentid: bookshipmentid}});
            });
        }
      });
  }

  isFormElementInValid(fullFormControlName: string) {
    const fromElement = this.hhgRateQueryForm.get(fullFormControlName);
    return fromElement && fromElement.invalid &&
      fromElement.touched;
  }

  isQueryButtonEnabled(): boolean {
    const rateType = this.hhgRateQueryForm.get('rateType')?.value;
    const estimatedWeight = this.hhgRateQueryForm.get('estimatedWeight')?.value;
    
    // For Extended Storage, only check essential fields
    if (rateType === 'Extended Storage') {
      const pickupDate = this.hhgRateQueryForm.get('pickupDate')?.value;
      const sroMasterId = this.hhgRateQueryForm.get('sroMasterId')?.value;
      const originCity = this.hhgRateQueryForm.get('origin.usaLocation.cityName')?.value;
      const originState = this.hhgRateQueryForm.get('origin.usaLocation.state')?.value;
      const originZip = this.hhgRateQueryForm.get('origin.usaLocation.zip')?.value;
      
      if (!pickupDate || !rateType || !sroMasterId || !estimatedWeight || !originCity || !originState || !originZip) {
        return false;
      }
      
      const weight = Number(estimatedWeight);
      return weight >= 500;
    }
    
    // For other rate types, check overall form validity
    if (!this.hhgRateQueryForm || this.hhgRateQueryForm.invalid) {
      return false;
    }
    
    if (!estimatedWeight) {
      return false;
    }
    
    const weight = Number(estimatedWeight);
    return weight >= 1000;
  }

  resetForm() {
    this.showResults = false;
    this.hhgRateQueryService.hhgRateQueryFormState.next(null);
    this.hhgRateQueryResults$ = of([] as HHGRateQueryResult[]);
    this.hhgRateQueryFormInitialize();
  }

  ngOnDestroy() {
    this.observer$.next(false);
  }

  onBreakdownChange() {
    const breakdownControl = this.hhgRateQueryForm.get('sitBreakdown');
    const noOfDaysControl = this.hhgRateQueryForm.get('noOfDays');
    if (!breakdownControl || !noOfDaysControl) {
      return;
    }

    const value = breakdownControl.value;
    if ((value || '').toString().trim().toUpperCase() === 'YES') {
      noOfDaysControl.enable();
    } else {
      noOfDaysControl.disable();
      noOfDaysControl.setValue(null);
    }
  }

  retireDeadc(): void {
    if (this.sroListOriginal?.length && new Date(this.hhgRateQueryForm.get('pickupDate')?.value) >= new Date('2023-11-01')) {
      this.sroList = this.sroListOriginal.filter(s => { if (s.sroId !== 'DEADC') {return s; } }).sort((a, b) => a.sroId.localeCompare(b.sroId));
    } else {
      this.sroList = this.sroListOriginal;
    }
  }

  /*
  This function makes initialize the hhg rate query form with default fields
*/
  private hhgRateQueryFormInitialize() {
    this.hhgRateQueryForm = this.createHhgRateQueryForm();
    this.hhgRateQueryForm.get('noOfDays').disable();
    this.hhgRateQueryForm.get('pickupDate').valueChanges
      .pipe(startWith(this.hhgRateQueryForm.get('pickupDate').value),
        takeWhile(() => this.observer$.value))
      .subscribe(val => {
        this.filterCountriesByPickupDate(val);
        this.retireDeadc();
      });
    this.hhgRateQueryForm.get('rateType').valueChanges
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe((sroType: string) => {
        this.sroType.next(sroType);
        let pickupD = this.hhgRateQueryForm.get('pickupDate').value;
        this.moveDate.next(this.hhgRateQueryForm.get('pickupDate').value);
        this.hhgRateQueryResults$ = of([] as HHGRateQueryResult[]);
        this.hhgRateQueryForm.get('sroMasterId').setValue(null);
        this.resetDestinationFormGroup(sroType);
        if (sroType === 'Extended Storage' && this.defaultCountry.value) {
          this.hhgRateQueryForm.get('origin.country')?.setValue(this.defaultCountry.value);
        }
      });
    this.resetOriginAndDestinationEvents();
    this.defaultCountry.pipe(filter(value => value != null))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(defaultCountry => {
        if (this.hhgRateQueryForm.get('origin.country')) {
          this.hhgRateQueryForm
            .get('origin.country')
            .setValue(defaultCountry);
        }
        if (this.hhgRateQueryForm.get('destination.country')) {
          this.hhgRateQueryForm
            .get('destination.country')
            .setValue(defaultCountry);
        }
        this.hhgRateQueryService.hhgRateQueryFormState.pipe(first()).subscribe(state => state ?
          this.hhgRateQueryForm.patchValue(state) : null);
      });
  }
  
  private gettingShipmentID(){
    combineLatest([(this.sroType), (this.moveDate)])
    .pipe(
        filter(([sroValue, moveDateValue]) => !!sroValue && !!moveDateValue)
    )
    .subscribe(([a, b]: any) => {
        this.ratesSroMasterService.getSroLlistByBusinessTypeAndSroTypeAndPickupDate(a, b)
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(sroIds => {
                this.tmssloader.hide();
                this.sroListMaster = sroIds;
                const excludedSros = ['DOSDD', 'DVADI', 'DEADD', 'ARCWV', 'TCSWV', 'USPDC', 'OCCDC', 'SSADI', 'DOSDC', 'DOSHW', 'DOSSA', 'FDICC', 'FBPMD'];
                this.excludedSroMasterIds = sroIds.filter((element: any) => excludedSros.indexOf(element.sroId) !== -1);
                this.sroListOriginal = AppConstants.filterSros(
                    this.currentUser.agencyUser,
                    this.currentUser.roles[0].name === 'Agency Auditor' ? 'System Admin' : this.currentUser.roles[0].name,
                    sroIds,
                    this.currentUser.agencyMasterId,
                    'HHG',
                    this.currentUser.viewAllSro,
                    this.currentUser.viewAllAgySro,
                    '',
                    this.currentUser.agencyId,
                    this.currentUser.agencyCode
                )
                .sort((a: any, b: any) => a.sroId.localeCompare(b.sroId));
                this.retireDeadc();
            }, (error) => {
                this.tmssloader.hide();
                this.alertService.error('Error Getting SRO Master List. Please contact system administrator');
            });
    });
    ;
   
  }

  compareCountryFn(c1: StateCountry, c2: StateCountry) {
    return c1 && c2 ? c1.stateCountryId === c2.stateCountryId : c1 === c2;
  }

  /*
  This function creates the hhg rate query form with default fields
*/
  private createHhgRateQueryForm() {
    return this.fb.group({
      pickupDate: new UntypedFormControl(new Date(), {validators: [Validators.required], updateOn: 'blur'}),
      rateType: new UntypedFormControl(null, {validators: [Validators.required]}),
      sroMasterId: new UntypedFormControl(null, {validators: [Validators.required]}),
      containerizedShipments: new UntypedFormControl(false, {validators: [Validators.required]}),
      origin: this.addDefaultLocationFromGroup(),
      destination: this.addDefaultLocationFromGroup(),
      vehicleClass: new UntypedFormControl(null),
      estimatedWeight: new UntypedFormControl(null, {
        validators: [CommonValidators.numeric, Validators.required, Validators.minLength(4),
          Validators.min(1000), Validators.maxLength(8), Validators.pattern('^[0-9]{1,8}?$')]
      }),
      employeeFirstName: new UntypedFormControl(null, {validators: [Validators.minLength(1), Validators.maxLength(45)], updateOn: 'blur'}),
      employeeMiddleName: new UntypedFormControl(null, {validators: [Validators.minLength(1), Validators.maxLength(1)], updateOn: 'blur'}),
      employeeLastName: new UntypedFormControl(null, {validators: [Validators.minLength(1), Validators.maxLength(45)], updateOn: 'blur'}),
      noOfDays: new UntypedFormControl(null, {validators: [Validators.pattern('^[0-9]{1,5}?$')]}),
      sit: new UntypedFormControl('Destination'),
      sitBreakdown: new UntypedFormControl('No'),
    });
  }

  /*
      This function resets events for both origin and destination from groups
      Initialize on init and sro type changes
*/
  private resetOriginAndDestinationEvents() {
    this.hhgRateQueryForm.get('origin.country').valueChanges
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(country => {
        this.updateLocation(country, 'origin');
      });
    this.hhgRateQueryForm.get('destination.country').valueChanges
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(country => {
        this.updateLocation(country, 'destination');
      });
    this.hhgRateQueryForm.get('rateType').valueChanges
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(rateType => {
        if (rateType !== 'Extended Storage') {
          this.sitValues = ['Destination', 'Origin'];
          this.addFormElement('vehicleClass');
          this.addFormElement('sit');
          const allowedCountries = ['UNITED STATES', 'CANADA'];
          const originCountry = this.hhgRateQueryForm.get('origin.country') && this.hhgRateQueryForm.get('origin.country').value;
          const destinationCountry = this.hhgRateQueryForm.get('destination.country') && this.hhgRateQueryForm.get('destination.country').value;
          const originAllowed = originCountry && originCountry.stateCountryName && allowedCountries.indexOf(originCountry.stateCountryName.toUpperCase()) !== -1;
          const destinationAllowed = destinationCountry && destinationCountry.stateCountryName && allowedCountries.indexOf(destinationCountry.stateCountryName.toUpperCase()) !== -1;
          if (originAllowed && destinationAllowed) {
            this.addFormElement('noOfDays');
            this.addFormElement('sitBreakdown');
            this.onBreakdownChange();
          } else {
            this.removeFormElement('noOfDays');
            this.removeFormElement('sitBreakdown');
          }
        } else {
          this.removeFormElement('vehicleClass');
          this.removeFormElement('noOfDays');
          this.removeFormElement('sitBreakdown');
          this.removeFormElement('sit');
        }
      });
    combineLatest([this.hhgRateQueryForm.get('origin.country') &&
    this.hhgRateQueryForm.get('origin.country').valueChanges,
      this.hhgRateQueryForm.get('destination.country') &&
      this.hhgRateQueryForm.get('destination.country').valueChanges])
      .pipe(tap(() => this.calculateMilesEvent()),
        takeWhile(() => this.observer$.value))
      .subscribe(([originCountry, destinationCountry]) => {
        if (this.hhgRateQueryForm.get('rateType')?.value === 'Extended Storage') {
          this.removeFormElement('miles');
          this.removeFormElement('sit');
          this.removeFormElement('sitBreakdown');
          this.removeFormElement('noOfDays');
          return;
        }
        this.resetEstimateMileageControl();
        const milesCountries = ['UNITED STATES', 'CANADA'];
        const originIsUS = originCountry.stateCountryName.toUpperCase() === 'UNITED STATES';
        const destinationIsUS = destinationCountry.stateCountryName.toUpperCase() === 'UNITED STATES';
        const originIsUSorCanada = milesCountries.indexOf(originCountry.stateCountryName.toUpperCase()) !== -1;
        const destinationIsUSorCanada = milesCountries.indexOf(destinationCountry.stateCountryName.toUpperCase()) !== -1;
        if (this.hhgRateQueryForm.get('rateType')?.value !== 'Extended Storage') {
          this.sitValues = ['Destination', 'Origin'];
        }
        if ((originCountry.stateCountryName.toUpperCase() === 'UNITED STATES' || originCountry.stateCountryName.toUpperCase() === 'CANADA')
          && (destinationCountry.stateCountryName.toUpperCase() === 'UNITED STATES' || destinationCountry.stateCountryName.toUpperCase() === 'CANADA')) {
          this.addFormElement('sitBreakdown');
          this.addFormElement('noOfDays');
          this.removeFormElement('uabWeight');
          if (originCountry.stateCountryName.toUpperCase() === 'CANADA' || destinationCountry.stateCountryName.toUpperCase() === 'CANADA') {
            this.addFormElement('uabWeight', {
              validators: [CommonValidators.numeric, Validators.minLength(1), Validators.maxLength(8), Validators.min(100)],
              updateOn: 'blur'
            });
          }
          this.onBreakdownChange();
        } else {
          this.removeFormElement('sitBreakdown');
          this.removeFormElement('noOfDays');
          this.addFormElement('uabWeight', {
            validators: [CommonValidators.numeric, Validators.minLength(1), Validators.maxLength(8), Validators.min(100)],
            updateOn: 'blur'
          });
          if (!(milesCountries.indexOf(originCountry.stateCountryName.toUpperCase()) !== -1 && milesCountries.indexOf(destinationCountry.stateCountryName.toUpperCase()) !== -1)) {
            this.removeFormElement('miles');
          }
          return;
        }
        /*if (milesCountries.indexOf(originCountry.stateCountryName.toUpperCase()) === -1
            || milesCountries.indexOf(destinationCountry.stateCountryName.toUpperCase()) === -1) {
            this.removeFormElement('miles');
            this.addFormElement('uabWeight', { validators: [CommonValidators.numeric, Validators.minLength(1), Validators.maxLength(8)], updateOn: 'blur' });
            return;
        }*/

      });
  }

  /*
      This function resets events for destination from group
      Initialize on sro type changes
*/
  private resetDestinationFormGroup(sroType: string) {
    const containerizedControl = this.hhgRateQueryForm.get('containerizedShipments');
    if (sroType === 'Extended Storage') {
      containerizedControl?.clearValidators();
      containerizedControl?.updateValueAndValidity();
      this.removeFormElement('destination');
      this.removeFormElement('miles');
      this.removeFormElement('noOfDays');
      this.removeFormElement('sitBreakdown');
      this.removeFormElement('sit');
      this.hhgRateQueryForm.get('estimatedWeight').setValidators([
        CommonValidators.numeric, 
        Validators.required, 
        Validators.minLength(4),
        Validators.min(500), 
        Validators.maxLength(8), 
        Validators.pattern('^[0-9]{1,8}?$')
      ]);
      this.hhgRateQueryForm.get('estimatedWeight').updateValueAndValidity();
      this.minWeight = 500;
      return;
    } else {
      containerizedControl?.setValidators([Validators.required]);
      containerizedControl?.updateValueAndValidity();
      this.hhgRateQueryForm.get('estimatedWeight').setValidators([
        CommonValidators.numeric, 
        Validators.required, 
        Validators.minLength(4),
        Validators.min(1000), 
        Validators.maxLength(8), 
        Validators.pattern('^[0-9]{1,8}?$')
      ]);
      this.hhgRateQueryForm.get('estimatedWeight').updateValueAndValidity();
      this.minWeight = 1000;
    }
    if (!this.hhgRateQueryForm.get('destination')) {
      this.hhgRateQueryForm.addControl('destination', this.addDefaultLocationFromGroup());
      this.resetOriginAndDestinationEvents();
      this.hhgRateQueryForm.get('origin.country').setValue(this.defaultCountry.value);
      this.hhgRateQueryForm.get('destination.country').setValue(this.defaultCountry.value);
    }
  }

  private calculateMilesEvent() {
    if (!this.hhgRateQueryForm.get('origin.usaLocation.city') || !this.hhgRateQueryForm.get('destination.usaLocation.city')) {
      return;
    }
    this.hhgRateQueryForm.get('origin.usaLocation.city').valueChanges
      .pipe(map((originCity) => [originCity, this.hhgRateQueryForm.get('destination.usaLocation.city').value]))
      .pipe(filter((o) => o[0] != null && o[1] != null))
      .subscribe(([originCity, destinationCity]) => this.onOriginDestinationCityChange(originCity, destinationCity));
    this.hhgRateQueryForm.get('destination.usaLocation.city').valueChanges
      .pipe(map((destinationCity) => [this.hhgRateQueryForm.get('origin.usaLocation.city').value, destinationCity]))
      .pipe(filter((o) => o[0] != null && o[1] != null))
      .subscribe(([originCity, destinationCity]) => this.onOriginDestinationCityChange(originCity, destinationCity));
  }

  private onOriginDestinationCityChange(originCity, destinationCity) {
    const tacomaZipCode = 98421;

    let originZipCode = null;
    let destinationZipCode = null;

    if (originCity.stateAbbrev === 'AK' && destinationCity.stateAbbrev === 'AK') {

      originZipCode = originCity.zipCode;
      destinationZipCode = destinationCity.zipCode;

      this.estimatedMileageWarning = false;
      this.estimatedMileageWarningMessage = '';
    } else {

      originZipCode = originCity.stateAbbrev === 'AK' ? tacomaZipCode : originCity.zipCode;
      destinationZipCode = destinationCity.stateAbbrev === 'AK' ? tacomaZipCode : destinationCity.zipCode;
      if (originCity.stateAbbrev === 'AK') {
        this.estimatedMileageWarning = true;
        this.estimatedMileageWarningMessage = 'Mileage will be calculated from Tacoma to Destination.';
      } else if (destinationCity.stateAbbrev === 'AK') {
        this.estimatedMileageWarning = true;
        this.estimatedMileageWarningMessage = 'Mileage will be calculated from Origin to Tacoma.';
      } else {
        this.estimatedMileageWarning = false;
        this.estimatedMileageWarningMessage = '';
      }
    }
    if (originCity.stateAbbrev === 'AK' || destinationCity.stateAbbrev === 'AK') {
      this.addFormElement('uabWeight', {
        validators: [CommonValidators.numeric, Validators.minLength(1), Validators.maxLength(8), Validators.min(100)],
        updateOn: 'blur'
      });
    } else {
      this.removeFormElement('uabWeight');
    }
    // calling pc miler for non carrier users only
    if (AppConstants.isNotNullCondition(this.currentUser)) {
      if (!this.checkUserRole(carrier_user) && !this.checkUserRole(carrier_user_admin) && !this.checkUserRole(carrier_user_RF)) {
        this.ratesSroMasterService
          .getMiles(originZipCode, destinationZipCode, 'HHG', this.hhgRateQueryForm.get('pickupDate').value.toISOString())
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(miles => {
            if (this.hhgRateQueryForm.get('miles')) {
              this.hhgRateQueryForm.get('miles').setValue(miles);
            }
          });
      }
    }
  }

  /*
     This function resets events for Miles
     Initialize on init and destination/origin country changes
 */

  private resetEstimateMileageControl() {
    if (this.hhgRateQueryForm.get('miles')) {
      return;
    }
    this.hhgRateQueryForm.addControl('miles', new UntypedFormControl(null, {
      validators: [
        Validators.pattern('^-?[0-9]\\d*(\\.\\d{1,2})?$'),
        Validators.required,
        Validators.min(1),
        Validators.max(99999),
      ],
      updateOn: 'blur'
    }));
    this.hhgRateQueryForm
      .get('miles')
      .valueChanges.pipe(filter(value => value > 0))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(miles => {
        this.hhgRateQueryForm
          .get('miles')
          .patchValue(new RoundPipe().transform(miles), {
            onlySelf: true,
            emitEvent: false
          });
      });
  }

  private updateLocation(stateCountry: StateCountry, location: string) {
    if (stateCountry.stateCountryName === 'UNITED STATES') {
      this.addUSLocation(location);
      return;
    }
    if (stateCountry.stateCountryName === 'CANADA') {
      this.canadaStateCountryId.next(stateCountry.stateCountryId);
      this.addCanadaLocation(location);
      return;
    }
    this.removeLocation(location);
  }

  private addUSLocation(fromElementName: string) {
    this.removeCanadaLocation(fromElementName);
    if (this.hhgRateQueryForm.get(fromElementName + '.usaLocation')) {
      this.hhgRateQueryForm.get(fromElementName + '.usaLocation').reset();
      return;
    }
    const fromGroup = this.hhgRateQueryForm.get(fromElementName) as UntypedFormGroup;
    fromGroup.addControl('usaLocation', this.createUSALocationFromGroup());
    if (fromElementName === 'origin') {
      this.dataSourceOriginSearchResults$ = this.createSearchStringObservable(fromGroup);
    }
    if (fromElementName === 'destination') {
      this.dataSourceDestinationSearchResults$ = this.createSearchStringObservable(fromGroup);
    }
    fromGroup.get('usaLocation.city').valueChanges.pipe(filter(value => value))
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(city => {
        fromGroup.get('usaLocation.cityName').setValue(city.cityName);
        fromGroup.get('usaLocation.state').setValue(city.stateAbbrev);
        fromGroup.get('usaLocation.zip').setValue(city.zipCode);
      });
  }

  private createSearchStringObservable(fromGroup: UntypedFormGroup) {
    return Observable.create((observer: any) => {
      this.ratesSroMasterService
        .getLocations(
          fromGroup.get('usaLocation.searchString').value
        )
        .pipe(takeWhile(() => this.observer$.value))
        .subscribe((result: any) => {
          observer.next(result);
        });
    });
  }

  private addCanadaLocation(fromElementName: string) {
    this.removeUSALocation(fromElementName);
    if (this.hhgRateQueryForm.get(fromElementName + '.canadaLocation')) {
      this.hhgRateQueryForm.get(fromElementName + '.canadaLocation').reset();
      return;
    }
    const fromGroup = this.hhgRateQueryForm.get(fromElementName) as UntypedFormGroup;
    fromGroup.addControl('canadaLocation', this.createCanadaLocationFromGroup());
  }

  private removeLocation(fromElementName: string) {
    this.removeCanadaLocation(fromElementName);
    this.removeUSALocation(fromElementName);
  }

  private removeCanadaLocation(fromElementName: string) {
    if (this.hhgRateQueryForm.get(fromElementName + '.canadaLocation')) {
      const fromGroup = this.hhgRateQueryForm.get(fromElementName) as UntypedFormGroup;
      fromGroup.removeControl('canadaLocation');
    }
  }

  private removeUSALocation(fromElementName: string) {
    if (this.hhgRateQueryForm.get(fromElementName + '.usaLocation')) {
      const fromGroup = this.hhgRateQueryForm.get(fromElementName) as UntypedFormGroup;
      fromGroup.removeControl('usaLocation');
    }
  }

  private addDefaultLocationFromGroup() {
    return new UntypedFormGroup({
      country: new UntypedFormControl(null, [Validators.required])
    });
  }

  private createUSALocationFromGroup() {
    return new UntypedFormGroup({
      searchString: new UntypedFormControl(null, [Validators.required]),
      city: new UntypedFormControl(null, [Validators.required]),
      cityName: new UntypedFormControl(null, [Validators.required]),
      state: new UntypedFormControl(null, [Validators.required]),
      zip: new UntypedFormControl(null, [Validators.required]),
    });
  }

  private createCanadaLocationFromGroup() {
    return new UntypedFormGroup({
      province: new UntypedFormControl(null, [Validators.required])
    });
  }

  private addFormElement(fromElementName: string, options: any = {}) {
    if (this.hhgRateQueryForm.get(fromElementName)) {
      return;
    }
    this.hhgRateQueryForm.addControl(fromElementName,
      new UntypedFormControl(null, {updateOn: 'blur', ...options}));
    if (fromElementName === 'sit') {
      this.hhgRateQueryForm.get('sit').setValue('Destination');
    }
    if (fromElementName === 'sitBreakdown') {
      this.hhgRateQueryForm.get('sitBreakdown').setValue('No');
    }
  }

  private removeFormElement(fromElementName: string) {
    if (this.hhgRateQueryForm.get(fromElementName)) {
      this.hhgRateQueryForm.removeControl(fromElementName);
    }
  }

  getOriginCountries(countries: any[] | null) {
    if (!countries) {
      return [];
    }
    if (this.hhgRateQueryForm.get('rateType')?.value === 'Extended Storage') {
      return countries.filter(country => country.stateCountryCode === 'US00');
    }
    return countries;
  }

  private getHHGRateQueryRequest(): HHGRateQueryRequest {
    let request = new HHGRateQueryRequest();
    this.hhgRateQueryService.hhgRateQueryFormState.next(this.hhgRateQueryForm.value);
    const {origin, destination, ...hhgRateQueryFormValue} = this.hhgRateQueryForm.value;
    console.log(this.hhgRateQueryForm.value);
    request = {...request, ...hhgRateQueryFormValue};
    request.userId = request.updateId = this.currentUser ? this.currentUser.id : 0;
    request.organizationId = this.currentUser.organizationId; // to pass org id
    request.pickupDate = this.hhgRateQueryForm.value.pickupDate.toISOString();
    request.sroMasterId = this.hhgRateQueryForm.value.sroMasterId ? this.hhgRateQueryForm.value.sroMasterId : 1;
    request.updateDate = (new Date()).toISOString();
    request.savedFlag = true;
    request.originZipId = origin && origin.usaLocation ? origin.usaLocation.city.uspsZipId : null;
    request.destinationZipId = destination && destination.usaLocation ? destination.usaLocation.city.uspsZipId : null;
    request.originCountryId = this.getStateCountryID(origin);
    request.destinationCountryId = this.getStateCountryID(destination);
    request.sitLocation = this.hhgRateQueryForm.value.sit;
    if (this.hhgRateQueryForm.value.sitBreakdown === 'No') {
      request.sitBreakDown = false;
      request.sitNoDays = 0;
    } else {
      request.sitBreakDown = true;
      request.sitNoDays = this.hhgRateQueryForm.value.noOfDays;
    }

    if (request.rateType === 'Extended Storage') {
      this.extendedStorage = true;
      if (request.originZipId === null) {
        this.isInternational = true;
      } else {
        this.isInternational = false;
      }
    }

    if (request.rateType !== 'Extended Storage') {
      this.extendedStorage = false;
      if ((request.originZipId === null && origin.country.stateCountryName !== 'CANADA') || (request.destinationZipId === null && destination.country.stateCountryName !== 'CANADA')) {
        this.isInternational = true;
      } else {
        this.isInternational = false;
      }
    }
    const key = 'queryRequest';
    const value = JSON.stringify(request);
    sessionStorage.setItem(key, value);
    this.showUAB(this.hhgRateQueryForm.value, request);
    return request;
  }

  private showUAB(locations: any, request: any) {
    if (request.rateType === this.sroTypes[0]) {
      if (locations.destination.country?.stateCountryCode2Digit === locations.origin.country?.stateCountryCode2Digit) {
        if (locations.destination?.usaLocation?.state === 'AK' || locations.origin.usaLocation?.state === 'AK') {
          this.isShownUAB = true;
        }
      } else {
        if (locations.destination.country?.stateCountryCode2Digit?.toUpperCase() === 'US' ||
          locations.origin.country?.stateCountryCode2Digit.toUpperCase() === 'US') {
          this.isShownUAB = true;
        }
        if (locations.destination.country?.stateCountryName?.toUpperCase() === 'CANADA' ||
          locations.origin.country?.stateCountryName?.toUpperCase() === 'CANADA') {
          this.isShownUAB = true;
        }
      }
    }
  }

  private getStateCountryID(location: any) {
    if (!location || !location.country) {
      return null;
    }
    return location.country.stateCountryName.toUpperCase() === 'CANADA'
      ? location.canadaLocation.province.stateCountryId : location.country.stateCountryId;
  }

  private filterCountriesByPickupDate(pickupDate: Date) {
    this.allCountriesList$.subscribe((items: any) => {
      let tempVal = items;
      const find = items.some((item: any) => {
        return (item.stateCountryCode.toUpperCase() === '925E' || item.stateCountryCode.toUpperCase() === '925S');
      });

      const findHiOld = items.some((item: any) => {
        return (item.stateCountryCode.toUpperCase() === '210H') ;
      });

      const findHiNew = items.some((item: any) => {
        return (item.stateCountryCode.toUpperCase() === '210A' || item.stateCountryCode.toUpperCase() === '210B' || item.stateCountryCode.toUpperCase() === '210K'
            || item.stateCountryCode.toUpperCase() === '210L' || item.stateCountryCode.toUpperCase() === '210M' || item.stateCountryCode.toUpperCase() === '210I'
            || item.stateCountryCode.toUpperCase() === '210U') ;
      });

      if(new Date(pickupDate) > new Date("2024-05-01")){
        if(find === true){
          tempVal = items.filter((item: any) => {
            return item.stateCountryCode.toUpperCase() !== '925E' && item.stateCountryCode.toUpperCase() !== '925S';
          });
        }
      }else{
        if(find !== true) {
          tempVal = tempVal.push(this.removedCountry);
        }
      }

      if (findHiOld === true) {
        if(new Date(pickupDate) > new Date("2025-10-31")){
          tempVal = tempVal.filter((item: any) => {
            return item.stateCountryCode.toUpperCase() !== '210H';
          });
        } 
      }
      if (findHiNew === true) {
        if(new Date(pickupDate) < new Date("2025-11-01")){
          tempVal = tempVal.filter((item: any) => {
            return item.stateCountryCode.toUpperCase() !== '210A' && item.stateCountryCode.toUpperCase() !== '210B' && item.stateCountryCode.toUpperCase() !== '210K'
            && item.stateCountryCode.toUpperCase() !== '210L' && item.stateCountryCode.toUpperCase() !== '210M' && item.stateCountryCode.toUpperCase() !== '210I'
            && item.stateCountryCode.toUpperCase() !== '210U';
          });
        } 
      }
      this.moveDate.next(this.hhgRateQueryForm.get('pickupDate').value);
      this.allCountriesObj$.next(tempVal);
    });
  }

}
